import { Box } from '@material-ui/core';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { AUTHORIZATION_TYPE_SELECT_OPTIONS } from '@/components/modules/Webhooks/constants/AuthorizationTypeSelectOptions';
import { AuthorizationType } from '@/components/modules/Webhooks/schemas/AuthorizationType';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { JsonFormField } from '@/components/shared/components/NewContextForms/components/JsonFormField';
import { PasswordFormField } from '@/components/shared/components/NewContextForms/components/PasswordFormField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

export const AddOrEditWebhookForm = ({ fieldVariant, fullWidth }: FormGridOptions) => {
  const { watch, setValue } = useFormContext();

  const authorizationType = watch('authorizationType');

  useEffect(() => {
    if (authorizationType !== AuthorizationType.BASIC) {
      setValue('authorizationHeader', undefined);
    }
    if (authorizationType !== AuthorizationType.OAUTH_2) {
      setValue('authorization', undefined);
    }
  }, [authorizationType]);

  return (
    <Box py={2}>
      <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
        <TextFormField
          name={'target'}
          label={'WEBHOOK_URL'}
          placeholder={'http://www.yourdomain.com/notifications'}
          hint={'WEBHOOK_URL_HINT'}
        />
        <SelectFormField
          name={'authorizationType'}
          label={'AUTHORIZATION_TYPE'}
          selectOptions={AUTHORIZATION_TYPE_SELECT_OPTIONS}
        />
        {authorizationType === AuthorizationType.BASIC && (
          <TextFormField
            name={'authorizationHeader'}
            label={'AUTHORIZATION_HEADER'}
            placeholder="Bearer "
            inputProps={{ spellCheck: false }}
          />
        )}
        {authorizationType === AuthorizationType.OAUTH_2 && (
          <>
            <TextFormField name={'authorization.url'} label={'URL'} />
            <TextFormField name={'authorization.clientId'} label={'CLIENT_ID_OAUTH_2'} />
            <TextFormField name={'authorization.clientSecret'} label={'CLIENT_SECRET_OAUTH_2'} />
            <TextFormField name={'authorization.username'} label={'USERNAME'} />
            <PasswordFormField name={'authorization.password'} label={'PASSWORD'} />
          </>
        )}
        <JsonFormField name={'additionalPayload'} label={'ADDITIONAL_PAYLOAD'} />
      </FormGridContainer>
    </Box>
  );
};
